import { css } from "@emotion/react";
import { PropsWithChildren, ReactNode } from "react";

type FieldWithButtonsProps = PropsWithChildren<{
  buttons: ReactNode;
}>;

export default function FieldWithButtons(props: FieldWithButtonsProps) {
  const wrapperCss = css({
    display: "flex",
    alignItems: "start",
  });

  const inputCss = css({
    flex: 1,
  });
  const buttonsCss = css({
    display: "flex",
    flexDirection: "row",
  });
  return (
    <div css={wrapperCss}>
      <div css={inputCss}>{props.children}</div>
      <div css={buttonsCss}>{props.buttons}</div>
    </div>
  );
}
